import { wsService } from "./wsService";

import sections from "@/constants/sections";

const section = sections.SECTION_DOCUMENT_LEGAJOS;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function uploadDocument(formData) {
  return wsService.make_post_request(section + "/files-by-legajo", formData);
}


export const documentLegajoService = {
  section,
  filter,
  remove,
  create,
  update,
  uploadDocument
};
